import PERMISOS from "#constants/perfiles"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import { evaluationPost } from "#performance-evaluation/services/api"
import { Box, Button } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"
import { useParams } from "react-router-dom"

export default function MyEvaluationsAdd({ hidden = false }) {
	const { refresh } = useReloadRefresh()

	const [disabled, setDisabled] = useState(false)
	const paramsUrl = useParams()
	const collaboratorId = paramsUrl["collaboratorId"]

	const success = () => refresh()

	const end = () => {
		setDisabled(false)
	}

	const isRh = UseHasPermission(PERMISOS.RH)
	const { fetch } = useApiSend(evaluationPost, { success, end })

	const handleClick = () => {
		setDisabled(true)
		fetch({ colaborador: collaboratorId })
	}

	if (!isRh || hidden) return null

	return (
		<Box display="flex" alignItems="left" justifyContent="flex-end" width="100%">
			<Button disabled={disabled} onClick={handleClick} color="success">
				Agregar Evaluacion
			</Button>
		</Box>
	)
}
